import { render } from "./edit-branch.vue?vue&type=template&id=d7eaf3b8"
import script from "./edit-branch.vue?vue&type=script&lang=js"
export * from "./edit-branch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__